module.exports = __webpack_public_path__ + "static/media/Facebook.70495f8f.svg";